import React, {useEffect, useState} from "react";
import ConfirmButton from "./ConfirmButton";
import {CommentField} from "../form/simpleFields/CommentField";
import ConfirmIconButton from "./ConfirmIconButton";
import {DateField} from "../form/simpleFields/DateField";


const ConfirmWithCommentAndDateButton = ({
                                             confirmTitle,
                                             confirmDescription,
                                             onConfirm,
                                             variant,
                                             tooltip,
                                             children,
                                             className,
                                             disabled,
                                             icon,
                                             comment,
                                             modalSize,
                                             buttonsConf,
                                             modelChildren,
                                             commentEnabled = true,
                                             commentRequired = true,
                                             dateRequired = true,
                                             setComment,
                                             setDate,
                                             dateValidation,
                                             date
                                         }) => {

    const [isCommentValid, setIsCommentValid] = useState(false);
    const [isDateValid, setIsDateValid] = useState(false);

    function validateComment() {
        if (
            commentRequired && (!comment || comment === "")
        ) {
            setIsCommentValid(false);
        } else {
            setIsCommentValid(true);
        }
    }

    function validateDate() {
        if (dateRequired && (!date || date === "")
        ) {
            setIsDateValid(false);
        } else {
            if (dateValidation) {
                const validationResult = dateValidation(date);
                setIsDateValid(validationResult)
            } else {
                setIsDateValid(true);

            }
        }
    }


    useEffect(validateComment, [comment]);
    useEffect(validateDate, [date]);


    return (
        <>
            {icon &&
                <ConfirmIconButton
                    variant={variant}
                    className={className}
                    disabled={disabled}
                    icon={icon}
                    ready={isCommentValid && isDateValid}
                    tooltip={tooltip}

                    confirmTitle={confirmTitle}
                    confirmDescription={confirmDescription}
                    onConfirm={onConfirm}
                    buttonsConf={buttonsConf}
                    additionalFields={<>
                        <DateField valid={isDateValid} onChange={e => setDate(e.target.value)}
                                   value={date}/>
                        {commentEnabled &&
                            <CommentField valid={isCommentValid} onChange={e => setComment(e.target.value)}
                                          value={comment}/>}
                        {modelChildren}

                    </>
                    }
                    form={true}
                    modalSize={modalSize}
                >{children}</ConfirmIconButton>
            }
            {!icon &&
                <ConfirmButton
                    variant={variant}
                    className={className}
                    disabled={disabled}
                    canConfirm={isCommentValid && isDateValid}
                    confirmTitle={confirmTitle}
                    confirmDescription={confirmDescription}
                    onConfirm={onConfirm}
                    buttonsConf={buttonsConf}
                    additionalFields={<>
                        <DateField valid={isDateValid} onChange={e => setDate(e.target.value)}
                                   value={date}/>
                        {commentEnabled &&
                            <CommentField valid={isCommentValid} onChange={e => setComment(e.target.value)}
                                          value={comment}/>
                        }
                        {modelChildren}


                    </>
                    }
                    form={true}
                    modalSize={"md"}

                >{children}</ConfirmButton>
            }
        </>
    );
};

export default ConfirmWithCommentAndDateButton;